export default __webpack_public_path__ + "static/media/contact_us_bg.bc6fbca8.png";